import { UpdateSubtitleCloudFileRequest } from "../../../../../../../../common/api/master-api/cloud-files/update/UpdateSubtitleCloudFileRequest";
import { RequestBuilderParams } from "./RequestBuilderParams";

export const buildUpdateSubtitleCloudFileRequest = ({
    cloudFileId,
    contentRef,
    selectedLanguages
}: RequestBuilderParams): UpdateSubtitleCloudFileRequest => {
    const subtitleLanguageId = selectedLanguages.subtitleLanguageId ?? undefined;

    return {
        cloudFileId,
        contentDetails: contentRef,
        subtitleLanguageId
    };
};
